import React, { useEffect, useState } from 'react'
import { useGetContractPeriodQuery } from '../../../store/auth/authService'
import moment from 'moment'
import { useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next' 
import { useForm } from 'react-hook-form'
import FilterBalance from './FilterBalance'
import MobileFilters from './MobileFilters'
import FilterDatePeriodYear from '../../tableHelpers/filters/FilterDatePeriodYear'
import { ImageDownloadButton } from '../ImageDownloadButton'
import { Checkbox } from '@material-tailwind/react'
import { SaldoFormType } from '../common.types'

const FiltersSaldo = (props: {
    value: SaldoFormType,
    isLoadingFetch: boolean,
    fetchPage: any,
    savePicture: any,
    saveExcel: any,
    isAllocation: boolean,
    setActiveDateCommon: any,
    activeDateCommon: any,
    // defaulPeriodFrom: string,
    // defaulPeriodTo: string,
}) => {
    const {
        value,
        isLoadingFetch,
        fetchPage,
        savePicture,
        isAllocation,
        activeDateCommon,
        setActiveDateCommon,
        saveExcel
        // defaulPeriodFrom,
        // defaulPeriodTo
    } = props

    const { t } = useTranslation()
    const { param_contract_id } = useParams()
    const { data } = useGetContractPeriodQuery({
        contract_id: param_contract_id,
        endOffset: 3
    })
    const {
        control,
        getValues,
        setValue,
    } = useForm<SaldoFormType>({
        defaultValues: {},
    })

    useEffect(() => {
        setValue('periodFrom', value.periodFrom)
        setValue('periodTo', value.periodTo)
        setValue('balance_id', value.balance_id)

    }, [value]);


    const [filtersState, setFiltersState] = useState<SaldoFormType>(value);

    const handleCloseFilter = () => {
        const values = getValues()
        setFiltersState(values)

        if (activeDateCommon) {
            setActiveDateCommon({
                periodFrom: values.periodFrom,
                periodTo: values.periodTo,
            })
        }
        if (JSON.stringify(values) !== JSON.stringify(filtersState)) {
            // fetch page with new filters 
            fetchPage(values)
        }
    }

    return (

        <div className='flex flex-wrap tab:flex-row tab:flex-nowrap  justify-between items-center mb-[24px] tab:mb-[32px] mt-[12px] gap-[8px]'>

            <MobileFilters
                defaultState={{
                    periodFrom: value.periodFrom,
                    periodTo: value.periodTo,
                    balance_id: value.balance_id,
                }}
                handleCloseFilters={handleCloseFilter}
                control={control}
                datesData={data}
                filtersState={filtersState}
            />
            <div className='tab:hidden grow'>
                <FilterBalance
                    defaultValue={value.balance_id}
                    control={control}
                    label={t('filters.type_balance')}
                    fieldName={'balance_id'}
                    filtersData={[
                        {
                            value: 1,
                            label: 'balance_1',
                            disabled: false
                        },
                        {
                            value: 2,
                            label: 'balance_2',
                            disabled: !isAllocation
                        },
                    ]}
                    handleCloseFilter={handleCloseFilter}
                />
            </div>

            <div className='hidden w-full tab:flex gap-[8px] justify-between'>
                <div className='flex gap-[8px] '>
                    <FilterDatePeriodYear
                        isLoadingFetch={isLoadingFetch || !value.periodFrom}
                        placement={'bottom-start'}
                        control={control}
                        fieldName1={'periodFrom'}
                        fieldName2={'periodTo'}
                        label1={t("filters.period_from")}
                        label2={t("filters.period_to")}
                        datesData={data}
                        handleCloseFilter={handleCloseFilter}
                        isDisabled1={(date: string) => {
                            return false
                        }}
                        isDisabled2={(date: string) => {
                            return moment(filtersState.periodFrom, 'MM-YYYY').add(1, 'month').isAfter(moment(date, 'MM-YYYY'))
                        }}
                        dateFormatter1={(date: string, dateTo: string) => {
                            if (moment(date, 'MM-YYYY').isAfter(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(11, 'month').isBefore(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(1, 'month').isAfter(moment(dateTo, 'MM-YYYY'))) {
                                return moment(date, 'MM-YYYY').add(11, 'month').format('MM-YYYY')
                            }
                            else {
                                return dateTo
                            }
                        }}
                        dateFormatter2={(date: string, dateFrom: string) => {
                            if (moment(date, 'MM-YYYY').isBefore(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(-11, 'month').isAfter(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(-1, 'month').isBefore(moment(dateFrom, 'MM-YYYY'))) {
                                return moment(date, 'MM-YYYY').add(-11, 'month').format('MM-YYYY')
                            }
                            else {
                                return dateFrom
                            }
                        }}
                    />
                    <Checkbox
                        labelProps={{
                            className: 'text-[14px] des:text-[16px]'
                        }}
                        label={t('analytics.active_date_common')}
                        checked={!!activeDateCommon}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setActiveDateCommon({
                                    periodFrom: value.periodFrom,
                                    periodTo: value.periodTo,
                                })
                            }
                            else {
                                setActiveDateCommon(null)
                            }
                        }}
                    />
                </div>
                <FilterBalance
                    defaultValue={value.balance_id}
                    control={control}
                    label={t('filters.type_balance')}
                    fieldName={'balance_id'}
                    filtersData={[
                        {
                            value: 1,
                            label: 'balance_1',
                            disabled: false
                        },
                        {
                            value: 2,
                            label: 'balance_2',
                            disabled: !isAllocation
                        },
                    ]}
                    handleCloseFilter={handleCloseFilter}
                />

            </div>

            <ImageDownloadButton
                text={t('download')}
                handleDownloadPng={savePicture}
                handleDownloadExcel={saveExcel}
                disabled={isLoadingFetch}
            />
        </div>
    )
}

export default FiltersSaldo